module.exports = __webpack_public_path__ + "static/media/logo.058c0db7.png";